import Loadable from 'react-loadable';

import {
  // home page
  HOME_PAGE_LINK,
  // about
  EN_ABOUT_PAGE_LINK,
  VI_ABOUT_PAGE_LINK,
  // location
  EN_LOCATION_PAGE_LINK,
  VI_LOCATION_PAGE_LINK,
  // amenities
  EN_AMENITIES_PAGE_LINK,
  VI_AMENITIES_PAGE_LINK,
  // site-plan
  EN_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK,
  VI_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK,
  EN_SITE_PLAN_DETAIL_PAGE_LINK,
  VI_SITE_PLAN_DETAIL_PAGE_LINK,
  EN_SITE_PLAN_PAGE_LINK,
  VI_SITE_PLAN_PAGE_LINK,

  // news
  EN_NEWS_DETAIL_PAGE_LINK,
  VI_NEWS_DETAIL_PAGE_LINK,
  EN_NEWS_PAGE_LINK,
  VI_NEWS_PAGE_LINK,

  // home profile
  HOME_PROFILE_PAGE_LINK,
  // home profile / add on
  HOME_PROFILE_ADD_ON_PAGE_LINK,

  // default page
  NOT_AVAILABLE_PAGE_LINK,
  NOT_FOUND_PAGE_LINK,

  // content path page
  CONTENT_PATH_EN_HOME_PAGE_LINK,
  CONTENT_PATH_VI_HOME_PAGE_LINK,

  // content path module page / about
  CONTENT_PATH_EN_MODULE_ABOUT_PAGE_LINK,
  CONTENT_PATH_VI_MODULE_ABOUT_PAGE_LINK,
  // content path module page / location
  CONTENT_PATH_EN_MODULE_LOCATION_PAGE_LINK,
  CONTENT_PATH_VI_MODULE_LOCATION_PAGE_LINK,
  // content path module page / amenities
  CONTENT_PATH_EN_MODULE_AMENITIES_PAGE_LINK,
  CONTENT_PATH_VI_MODULE_AMENITIES_PAGE_LINK,
  // content path module page / site-plan
  CONTENT_PATH_EN_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK,
  CONTENT_PATH_VI_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK,
  CONTENT_PATH_EN_MODULE_SITE_PLAN_DETAIL_PAGE_LINK,
  CONTENT_PATH_VI_MODULE_SITE_PLAN_DETAIL_PAGE_LINK,
  CONTENT_PATH_EN_MODULE_SITE_PLAN_PAGE_LINK,
  CONTENT_PATH_VI_MODULE_SITE_PLAN_PAGE_LINK,

  // content path page / news
  CONTENT_PATH_EN_NEWS_DETAIL_PAGE_LINK,
  CONTENT_PATH_VI_NEWS_DETAIL_PAGE_LINK,
  CONTENT_PATH_EN_NEWS_PAGE_LINK,
  CONTENT_PATH_VI_NEWS_PAGE_LINK,

  // content path page / home profile
  CONTENT_PATH_EN_HOME_PROFILE_PAGE_LINK,
  CONTENT_PATH_VI_HOME_PROFILE_PAGE_LINK,
  // content path page / home profile / add on
  CONTENT_PATH_EN_HOME_PROFILE_ADD_ON_PAGE_LINK,
  CONTENT_PATH_VI_HOME_PROFILE_ADD_ON_PAGE_LINK,

  // self-home-profile page root
  EN_SELF_HOME_PROFILE_PAGE_LINK,
  VI_SELF_HOME_PROFILE_PAGE_LINK,
  // self-home-profile / add on page root
  EN_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK,
  VI_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK,
  JP_SELF_HOME_PROFILE_PAGE_LINK,
  JP_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK,
  JP_ABOUT_PAGE_LINK,
  JP_LOCATION_PAGE_LINK,
  JP_AMENITIES_PAGE_LINK,
  JP_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK,
  JP_SITE_PLAN_DETAIL_PAGE_LINK,
  JP_SITE_PLAN_PAGE_LINK,
  JP_NEWS_DETAIL_PAGE_LINK,
  JP_NEWS_PAGE_LINK,
  CONTENT_PATH_JP_MODULE_ABOUT_PAGE_LINK,
  CONTENT_PATH_JP_MODULE_LOCATION_PAGE_LINK,
  CONTENT_PATH_JP_MODULE_AMENITIES_PAGE_LINK,
  CONTENT_PATH_JP_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK,
  CONTENT_PATH_JP_MODULE_SITE_PLAN_DETAIL_PAGE_LINK,
  CONTENT_PATH_JP_MODULE_SITE_PLAN_PAGE_LINK,
  CONTENT_PATH_JP_NEWS_DETAIL_PAGE_LINK,
  CONTENT_PATH_JP_NEWS_PAGE_LINK,
  CONTENT_PATH_JP_HOME_PROFILE_ADD_ON_PAGE_LINK,
  CONTENT_PATH_JP_HOME_PROFILE_PAGE_LINK,
  CONTENT_PATH_JP_HOME_PAGE_LINK,
} from '../commons/constants';

const LoadableLoading = () => <></>;
const loadable = (
  loader: () => Promise<React.ComponentType<any> | { default: React.ComponentType<any> }>
) =>
  Loadable({
    loader,
    delay: false,
    loading: LoadableLoading,
  });

export default {
  // self-home-profile page root
  [EN_SELF_HOME_PROFILE_PAGE_LINK]: {
    component: loadable(() => import('../pages/SelfHomeProfilePage')),
  },
  [JP_SELF_HOME_PROFILE_PAGE_LINK]: {
    component: loadable(() => import('../pages/SelfHomeProfilePage')),
  },
  [EN_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK]: {
    component: loadable(() => import('../pages/SelfHomeProfilePage')),
  },
  [JP_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK]: {
    component: loadable(() => import('../pages/SelfHomeProfilePage')),
  },
  [VI_SELF_HOME_PROFILE_PAGE_LINK]: {
    component: loadable(() => import('../pages/SelfHomeProfilePage')),
  },
  [VI_SELF_HOME_PROFILE_ADD_ON_PAGE_LINK]: {
    component: loadable(() => import('../pages/SelfHomeProfilePage')),
  },

  // about
  [EN_ABOUT_PAGE_LINK]: {
    component: loadable(() => import('../pages/AboutPage')),
  },
  [VI_ABOUT_PAGE_LINK]: {
    component: loadable(() => import('../pages/AboutPage')),
  },
  [JP_ABOUT_PAGE_LINK]: {
    component: loadable(() => import('../pages/AboutPage')),
  },

  // location
  [EN_LOCATION_PAGE_LINK]: {
    component: loadable(() => import('../pages/LocationPage')),
  },
  [VI_LOCATION_PAGE_LINK]: {
    component: loadable(() => import('../pages/LocationPage')),
  },
  [JP_LOCATION_PAGE_LINK]: {
    component: loadable(() => import('../pages/LocationPage')),
  },

  // amenities
  [EN_AMENITIES_PAGE_LINK]: {
    component: loadable(() => import('../pages/AmenitiesPage')),
  },
  [VI_AMENITIES_PAGE_LINK]: {
    component: loadable(() => import('../pages/AmenitiesPage')),
  },
  [JP_AMENITIES_PAGE_LINK]: {
    component: loadable(() => import('../pages/AmenitiesPage')),
  },

  // site-plan
  [EN_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanDetailPage')),
  },
  [VI_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanDetailPage')),
  },
  [JP_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanDetailPage')),
  },
  [EN_SITE_PLAN_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanDetailPage')),
  },
  [VI_SITE_PLAN_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanDetailPage')),
  },
  [JP_SITE_PLAN_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanDetailPage')),
  },
  [EN_SITE_PLAN_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanPage')),
  },
  [VI_SITE_PLAN_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanPage')),
  },
  [JP_SITE_PLAN_PAGE_LINK]: {
    component: loadable(() => import('../pages/SitePlanPage')),
  },

  // news
  [EN_NEWS_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/NewsDetailPage')),
  },
  [VI_NEWS_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/NewsDetailPage')),
  },
  [JP_NEWS_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/NewsDetailPage')),
  },
  [EN_NEWS_PAGE_LINK]: {
    component: loadable(() => import('../pages/NewsPage')),
  },
  [VI_NEWS_PAGE_LINK]: {
    component: loadable(() => import('../pages/NewsPage')),
  },
  [JP_NEWS_PAGE_LINK]: {
    component: loadable(() => import('../pages/NewsPage')),
  },

  // home profile / add on
  [HOME_PROFILE_ADD_ON_PAGE_LINK]: {
    component: loadable(() => import('../pages/HomeProfilePage')),
  },
  // home profile
  [HOME_PROFILE_PAGE_LINK]: {
    component: loadable(() => import('../pages/HomeProfilePage')),
  },

  [HOME_PAGE_LINK]: {
    component: loadable(() => import('../pages/HomePage')),
  },

  // default pages
  [NOT_FOUND_PAGE_LINK]: {
    component: loadable(() => import('../pages/DefaultPages/NotFoundPage')),
  },
  [NOT_AVAILABLE_PAGE_LINK]: {
    component: loadable(() => import('../pages/DefaultPages/NotAvailablePage')),
  },
};

export const contextPathViLink = {
  // content path module page / about
  [CONTENT_PATH_VI_MODULE_ABOUT_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_EN_MODULE_ABOUT_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_JP_MODULE_ABOUT_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },

  // content path module page / location
  [CONTENT_PATH_VI_MODULE_LOCATION_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_EN_MODULE_LOCATION_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_JP_MODULE_LOCATION_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },

  // content path module page / amenities
  [CONTENT_PATH_VI_MODULE_AMENITIES_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_EN_MODULE_AMENITIES_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_JP_MODULE_AMENITIES_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },

  // content path module page / site-plan
  [CONTENT_PATH_VI_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_EN_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_JP_MODULE_SITE_PLAN_DETAIL_EXTENDABLE_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_VI_MODULE_SITE_PLAN_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_EN_MODULE_SITE_PLAN_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_JP_MODULE_SITE_PLAN_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_VI_MODULE_SITE_PLAN_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_EN_MODULE_SITE_PLAN_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_JP_MODULE_SITE_PLAN_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },

  // content path page / news
  [CONTENT_PATH_VI_NEWS_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_EN_NEWS_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_JP_NEWS_DETAIL_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModuleDetailPage')),
  },
  [CONTENT_PATH_VI_NEWS_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_EN_NEWS_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },
  [CONTENT_PATH_JP_NEWS_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectModulePage')),
  },

  // content path page / home profile / add on
  [CONTENT_PATH_VI_HOME_PROFILE_ADD_ON_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomeProfilePage')),
  },
  [CONTENT_PATH_EN_HOME_PROFILE_ADD_ON_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomeProfilePage')),
  },
  [CONTENT_PATH_JP_HOME_PROFILE_ADD_ON_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomeProfilePage')),
  },
  // content path page / home profile
  [CONTENT_PATH_VI_HOME_PROFILE_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomeProfilePage')),
  },
  [CONTENT_PATH_EN_HOME_PROFILE_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomeProfilePage')),
  },
  [CONTENT_PATH_JP_HOME_PROFILE_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomeProfilePage')),
  },

  // content path page
  [CONTENT_PATH_VI_HOME_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomePage')),
  },
  [CONTENT_PATH_EN_HOME_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomePage')),
  },
  [CONTENT_PATH_JP_HOME_PAGE_LINK]: {
    component: loadable(() => import('../pages/ProjectHomePage')),
  },
};
